// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - TEXTFIELD ||============================== //

export default function TextField(theme: Theme) {
  const { mode } = theme.palette;
  const isClassic = mode === 'dark' && theme.palette.background.default === '#000000';

  return {
    MuiTextField: {
      styleOverrides: {
        root: {
          ...(isClassic && {
            '& .MuiOutlinedInput-root': {
              backgroundColor: '#2d2d2d',
              '& fieldset': {
                borderColor: '#404040',
              },
              '&:hover fieldset': {
                borderColor: '#525252',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#FFD700',
              },
              '& input': {
                color: '#FFD700',
                '&::placeholder': {
                  color: '#808080',
                  opacity: 1,
                },
              },
            },
            '& .MuiInputLabel-root': {
              color: '#FFD700', // Gold color for Classic theme only
              '&.Mui-focused': {
                color: '#FFD700', // Gold color when focused
              },
            },
            '& .MuiFormHelperText-root': {
              color: '#cccccc',
            },
          }),
        },
      },
    },
  };
} 